<template>
	<div class="register-main" v-loading="loading">
		<my-header></my-header>
		<div class="register-container">
			<el-form :model="registerForm" :rules="registerRules" ref="registerForm" status-icon>
				<p class="register-title">用户注册信息填写</p>
				<el-form-item label="用户名" prop="username" label-width="80px">
					<el-tooltip class="item" effect="dark" content="用户名3~15位，只支持输入数字、字母和减号" placement="right">
						<el-input v-model="registerForm.username" type="text" auto-complete="off"></el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="密码" prop="password" label-width="80px">
					<el-tooltip class="item" effect="dark" content="密码最低6位，只支持数字、字母和下划线" placement="right">
						<el-input v-model="registerForm.password" type="password" auto-complete="off"></el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="确认密码" prop="rePassword" label-width="80px">
					<el-tooltip class="item" effect="dark" content="请再次输入您的密码" placement="right">
						<el-input v-model="registerForm.rePassword" type="password" auto-complete="off"></el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="真实姓名" prop="real_name" label-width="80px">
					<el-tooltip class="item" effect="dark" content="请填写真实姓名" placement="right">
						<el-input v-model="registerForm.real_name" type="text" auto-complete="off"></el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="移动电话" prop="mobile" label-width="80px">
					<el-tooltip class="item" effect="dark" content="请填写正确的手机号" placement="right">
						<el-input v-model="registerForm.mobile" type="phone" auto-complete="off"></el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item label="电子邮件" prop="email" label-width="80px">
					<el-tooltip class="item" effect="dark" content="请填写正确的邮件地址" placement="right">
						<el-input v-model="registerForm.email" type="email" auto-complete="off"></el-input>
					</el-tooltip>
				</el-form-item>
				<el-form-item label-width="80px" prop="agree">
					<el-checkbox v-model="registerForm.agree">我已阅读并同意</el-checkbox>
					<!--<el-button class="primary-text" @click="registerProtocol = true">《用户注册协议》</el-button>-->
					<a href="#" @click="registerProtocol = true" style="color: #2989dd;">《用户注册协议》</a>
					<!--<a href="#" class="form-item">《用户注册协议》</a>-->
				</el-form-item>
				<el-form-item label-width="80px">
					<el-button class="oldprimary" @click="submitRegister" style="width:100%;">同意协议并注册</el-button>
				</el-form-item>
				<div class="register-login">
					<a class="register-login-content" href="#" @click="toLogin">已有账号？马上登录</a>
				</div>
			</el-form>
		</div>
		<!--<img class="bg-bottom" src="../assets/images/login/bg-bottom.png">-->

		<!--用户注册协议弹窗start-->
		<el-dialog title="用户注册协议" :visible.sync="registerProtocol" width="60%" class="registerProtocol" :showClose="false">
			<p class="one-level">1 本服务条款是用户与北京天智互动科技有限公司（下称天智）之间的协议。天智网站由天智或其关联公司所运行的各个网站和网页构成。</p>
			<p class="second-level">1.1 重要须知： 天智在此特别提醒，用户欲访问和使用天智网站，必须事先认真阅读本服务条款中各条款， 包括免除或者限制天智责任的免责条款及对用户的权利限制。请您审阅并接受或不接受本服务条款（未成年人审阅时应得到法定监护人的陪同）。如您不同意本服务条款及/或随时对其的修改，您应不使用或主动取消天智公司提供的服务。您的使用行为将被视为您对本服务条款全部的完全接受，包括接受天智对服务条款随时所做的任何修改。</p>
			<p class="second-level">1.2 这些条款可由天智随时更新，且毋须另行通知。天智服务条款(以下简称“服务条款”)一旦发生变更, 天智将在网页上公布修改内容。修改后的服务一旦在网页上公布即有效代替原来的服务条款。您可随时登录天智网站查阅最新版服务条款。</p>
			<p class="one-level">2 用户使用规则：</p>
			<p class="second-level">2.1 用户必须自行配备上网和使用电信增值业务所需的设备，自行负担个人上网或第三方（包括但不限于电信或移动通信提供商）收取的通讯费、信息费等有关费用。如涉及电信增值服务的，我们建议您与您的电信增值服务提供商确认相关的费用问题。</p>
			<p class="second-level">2.2 不得发送任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、庸俗性、淫秽色情性等内容的信息。</p>
			<p class="second-level">2.3 保证自己在使用各服务时用户身份的真实性和正确性及完整性，如果资料发生变化，您应及时更改。在完成本服务的登记后，您应维持密码及帐号的机密安全。您应对任何人利用您的密码及帐号所进行的活动负完全的责任，天智公司无法对非法或未经您授权使用您帐号及密码的行为作出甄别，因此天智公司不承担任何责任。在此，您同意并承诺做到∶</p>
			<p class="third-level">2.3.1 当您的密码或帐号遭到未获授权的使用，或者发生其他任何安全问题时，您会立即有效通知到天智公司；</p>
			<p class="third-level">2.3.2 当您每次上网或使用其他服务完毕后，会将有关帐号安全退出；</p>
			<p class="second-level">2.4 用户同意接受天智通过电子邮件网页或其他合法方式向用户发送商品促销或其他相关商业信息。在使用电信增值服务的情况下，用户同意接受本公司及合作公司通过增值服务系统或其他方式向用户发送的相关服务信息或其他信息，其他信息包括但不限于通知信息、宣传信息、广告信息等。</p>
			<p class="second-level">2.5 关于在天智张贴的公开信息：</p>
			<p class="third-level">2.5.1 您同意您在本服务公开使用区域或服务项目内张贴之内容，包括但不限于照片、图形或影音资料等内容，授予天智全球性、免许可费、非独家、可完全转授权、及永久有效的使用权利，天智可以为了展示、散布及推广张贴前述内容之特定目的，将前述内容复制、修改、改写、改编或出版。</p>
			<p class="third-level">2.5.2 对您张贴的内容，您保证已经拥有必要权利或授权以进行该内容提供、张贴、上载、提交等行为。</p>
			<p class="third-level">2.5.3 若您违反有关法律法规及本服务条款的规定了，须自行承担完全的法律责任，并承担因此给天智公司造成的损失的法律责任。</p>
			<p class="second-level">2.6 关于收费服务</p>
			<p class="third-level">2.6.1 天智的某些服务是以收费方式提供的。一旦您本人或他人（包括您的代理）通过个人帐户订阅收费服务，您应按有关的收费标准、付款方式支付相关服务费及其他费用。资费说明标明在天智网站相应服务的相应页面上。　您可以通过我们的客户服务中心选择取消相关付费服务。在您正式取消相关服务并经天智批准前，我们将按相关服务的收费标准与方式继续收费。</p>
			<p class="third-level">2.6.2 逾期付费：服务费之逾期交纳应按天智公司或合作公司关于迟延付费的相应规定办理。</p>
			<p class="second-level">2.7 遵守国家的有关法律、法规和行政规章制度，相关法律、法规和制度。</p>
			<p class="second-level">2.8 如用户违反国家法律法规或本服务条款，本公司和合作公司将有权停止向用户提供服务而不需承担任何责任，如导致天智或合作公司遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向本公司或合作公司赔偿相应的损失，用户并需对其违反服务条款所产生的一切后果负全部法律责任。</p>
			<p class="one-level">3 服务风险及免责声明</p>
			<p class="second-level">3.1 用户须明白，本服务仅依其当前所呈现的状况提供，本服务涉及到互联网及移动通讯等服务，可能会受到各个环节不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、GSM网络、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。开通服务的用户须承担以上风险，本公司和合作公司对服务之及时性、安全性、准确性不作担保，对因此导致用户不能发送和接受阅读消息、或传递错误，个人设定之时效、未予储存或其他问题不承担任何责任。</p>
			<p class="second-level">3.2 如本公司的系统发生故障影响到本服务的正常运行，本公司承诺在第一时间内与相关单位配合，及时处理进行修复。但用户因此而产生的经济损失，本公司和合作公司不承担责任。此外，天智保留不经事先通知为维修保养、升级或其他目的暂停本服务任何部分的权利。</p>
			<p class="second-level">3.3 天智公司公司在此郑重提请您注意，任何经由本服务以上载、张贴、发送即时信息、电子邮件或任何其他方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息、用户的登记资料或其他资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。天智公司无法控制经由本服务传送之内容，也无法对用户的使用行为进行全面控制，因此不保证内容的合法性、正确性、完整性、真实性或品质；您已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容，并同意将自行加以判断并承担所有风险，　而不依赖于天智公司。但在任何情况下，天智公司有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。但天智公司有权(但无义务)依其自行之考量，拒绝和删除可经由本服务提供之违反本条款的或其他引起天智公司或其他用户反感的任何内容。</p>
			<p class="second-level">3.4 关于使用及储存之一般措施：您承认关於本服务的使用天智有权制订一般措施及限制，包含但不限於本服务将保留用户信息、电子邮件信息、所张贴内容或其他上载内容之最长期间、本服务一个帐号当中可收发电子邮件或短信讯息等的最大数量、本服务一个帐号当中可收发的单个信息或电子邮件的大小、天智服务器为您分配的最大使用空间，以及一定期间内您使用本服务之次数上限（及每次使用时间之上限）。通过本服务存储或传送之任何信息、通讯资料和其他内容，如被删除或未予储存，您同意天智毋须承担任何责任。您亦同意，长时间未使用的帐号，天智有权关闭并收回帐号。您也同意，天智有权依其自行之考量，不论通知与否，随时变更这些一般措施及限制。</p>
			<p class="second-level">3.5 与广告商进行之交易 : 您通过本服务与广告商进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其他任何相关条款、条件、保证或声明，完全为您与广告商之间之行为。除有关法律有明文规定要求天智承担责任以外，您因前述任何交易或前述广告商而遭受的任何性质的损失或损害，天智均不予负责。</p>
			<p class="second-level">3.6 链接及搜索引擎服务： 本服务或第三人可提供与其他国际互联网上之网站或资源之链接。由於天智无法控制这些网站及资源，您了解并同意：无论此类网站或资源是否可供利用，天智不予负责；天智亦对存在或源於此类网站或资源之任何内容、广告、产品或其他资料不予保证或负责。因您使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、商品或服务所产生的任何损害或损失，天智不负任何直接或间接之责任。若您认为该链接所载的内容或搜索引擎所提供之链接的内容侵犯您的权利，天智声明与上述内容无关，不承担任何责任。天智建议您与该网站或法律部门联系，寻求法律保护；若您需要更多了解天智之搜索服务，请参见天智关于搜索引擎服务的相关说明。</p>
			<p class="one-level">4 服务变更、中断或终止及服务条款的修改</p>
			<p class="second-level">4.1 本服务的所有权和运作权、一切解释权归天智公司。天智公司提供的服务将按照其发布的章程、服务条款和操作规则严格执行。</p>
			<p class="second-level">4.2 本公司有权在必要时修改服务条款，服务条款一旦发生变动，将会在相关页面上公布修改后的服务条款。如果不同意所改动的内容，用户应主动取消此项服务。如果用户继续使用服务，则视为接受服务条款的变动。</p>
			<p class="second-level">4.3 本公司和合作公司有权按需要修改或变更所提供的收费服务、收费标准、收费方式、服务费、及服务条款。天智在提供服务时，可能现在或日后对部分服务的用户开始收取一定的费用如用户拒绝支付该等费用，则不能在收费开始后继续使用相关的服务。但天智和合作公司将尽最大努力通过电邮或其他有效方式通知用户有关的修改或变更。</p>
			<p class="second-level">4.4 本公司特别提请用户注意，本公司为了保障公司业务发展和调整的自主权，本公司拥有经或未经事先通知而修改服务内容、中断或中止部分或全部服务的权利，修改会以通告形式公布于天智网站相关页面上，一经公布视为通知。 天智公司行使修改或中断服务的权利而造成损失的，天智公司不需对用户或任何第三方负责。</p>
			<p class="second-level">4.5 如发生下列任何一种情形，本公司有权随时中断或终止向用户提供服务而无需通知用户：</p>
			<p class="third-level">4.5.1 用户提供的个人资料不真实；</p>
			<p class="third-level">4.5.2 用户违反本服务条款的规定；</p>
			<p class="third-level">4.5.3 按照主管部门的要求；</p>
			<p class="third-level">4.5.4 其他本公司认为是符合整体服务需求的特殊情形。</p>
			<p class="one-level">5 法律</p>
			<p class="second-level">5.1 本服务条款要与国家相关法律、法规一致，如发生服务条款与相关法律、法规条款有相抵触的内容，抵触部分以法律、法规条款为准。</p>
			<p class="one-level">6 保障</p>
			<p class="second-level">6.1 用户同意保障和维护本公司全体成员的利益，负责支付由用户使用超出服务范围引起的一切费用（包括但不限于：律师费用、违反服务条款的损害补偿费用以及其它第三人使用用户的电脑、帐号和其它知识产权的追索费）。</p>
			<p class="second-level">6.2 用户须对违反国家法律规定及本服务条款所产生的一切后果承担法律责任。</p>
			<p class="one-level">7 其它</p>
			<p class="second-level">7.1 如本服务条款中的任何条款无论因何种原因完全或部分无效或不具有执行力，本服务条款的其余条款仍应有效且具有约束力，并且努力使该规定反映之意向具备效力。</p>
			<p class="second-level">7.2 本服务条款构成您与天智之全部协议，规范您对本服务之使用，并取代您先前与天智达成的全部协议。但在您使用相关服务、或使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及权利。</p>
			<p class="second-level">7.3 每项服务的内容、收费标准、收费方式、服务费及服务条款应以最后发布的通知为准。</p>
			<p class="second-level" style="margin-top: 38px;font-weight: bold ;">*北京天智互动科技有限公司  保留本服务条款之解释权。</p>
			<div slot="footer" class="dialog-footer">
				<el-button class="primary" @click="registerProtocolAgree">同意协议</el-button>
			</div>
		</el-dialog>
		<!--用户注册协议弹窗end-->
	</div>
</template>

<script>
	import { isvalidPhone } from '@/assets/js/validate'
	import { register } from '@/api/user'
	export default {
		data() {

			//两次密码是否相等
			let validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.registerForm.password) {
					callback(new Error('两次输入密码请保持一致!'));
				} else {
					callback();
				}
			};
			let isAgree = (rule, value, callback)=>{
				if(value === true){
					callback();
				}else{
					callback(new Error('请同意协议才能注册账号'));
				}
			}
			//手机号验证
			let validPhone = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请输入电话号码'))
				} else if(!isvalidPhone(value)) {
					callback(new Error('请输入正确的11位手机号码'))
				} else {
					callback()
				}
			};

			return {
				loading:false,
				registerProtocol: false,
				agree: false,
				registerForm: {
					username: '',
					password: '',
					rePassword: '',
					real_name: '',
					mobile: '',
					email: '',
					agree:false
				},
				registerRules: {
					username: [{
							required: true,
							message: '请设置用户名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 15,
							message: '长度在 3 到 15 个字符',
							trigger: 'blur'
						},
						{
							pattern: /^[0-9a-zA-Z-]{1,}$/,
							message: "只支持输入数字、字母和减号",
							trigger: "blur"
						}
						//pattern: /[A-Za-z0-9]$/,
					],
					password: [{
							required: true,
							message: '请设置登录密码',
							trigger: 'blur'
						},
						{
							min: 6,
							message: '长度在6 个字符以上',
							trigger: 'blur'
						},
						{
							pattern: /^[0-9a-zA-Z_]{1,}$/,
							message: "只支持输入数字、字母和下划线",
							trigger: "blur"
						}
					],
					rePassword: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					},
					{
							pattern: /^[0-9a-zA-Z_]{1,}$/,
							message: "只支持输入数字、字母和下划线",
							trigger: "blur"
					}],
					real_name: [{
						required: true,
						message: '请设置真实姓名',
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						trigger: 'blur',
						validator: validPhone
					}],
					email: [{
							required: true,
							message: '请设置邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					],
					agree: [{
						required: true,
						validator: isAgree,
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			toLogin() {
				this.$router.push('/Login');
			},
			registerProtocolAgree(){
				this.registerForm.agree = true
				this.registerProtocol = false
			},
			submitRegister(){
				this.$refs.registerForm.validate(valid => {
					if (valid) {
						this.loading = true
						register(this.registerForm).then(() =>{
							this.loading = false
							this.$message({
								type: 'success',
								message: '注册成功'
							});
							this.registerForm = {}
							this.toLogin()
						}).catch(()=>{
							this.loading = false
						})
					} else {
						return false
					}
				})
			}
		},
	};
</script>

<style>
	@import url("../assets/css/style.css");
	.register-main {
		/*min-width: 950px;*/
		width: 100%;
		height: 100%;
		overflow: hidden;
		position: absolute;
	}
	
	.register-container {
		margin: auto;
		margin-top: 25px;
		width: 400px;
	}
	
	.register-title {
		margin-bottom: 22px;
		font-size: 32px;
		font-stretch: normal;
		font-weight: normal;
		line-height: 38px;
		letter-spacing: 0px;
		color: #333333;
		text-align: center;
	}
	
	.form-item {
		color: #0090ee;
	}
	
	.register-login {
		margin: auto;
		margin-top: 30px;
		width: 150px;
		height: 13px;
		line-height: 13px;
	}
	
	.register-login-content {
		margin-left: 20px;
		float: left;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 13px;
		letter-spacing: 0px;
		color: #2989dd;
	}
	
	.bg-bottom {
		position: absolute;
		height: 15%;
		bottom: 0px;
	}
	/*用户注册协议弹窗start*/
	.registerProtocol .el-dialog__header {
		text-align: center;
		font-size: 24px;
		font-weight: bold;
	}
	
	.registerProtocol .el-dialog {
		margin-top: 0px !important;
	}
	
	.one-level {
		margin-top: 18px;
		margin-bottom: 5px;
		font-weight: bold;
	}
	
	.second-level {
		text-indent: 2em;
		margin: 5px 0px;
	}
	
	.third-level {
		text-indent: 3em;
		margin: 5px 0px;
	}
	/*用户注册协议弹窗end*/
</style>


// WEBPACK FOOTER //
// src/components/Register.vue